import html2canvas from 'html2canvas';
export default function downloadHTMLElementAsPng(element, fileName) {
    if (!element) {
        console.error('Element is missing');
        return;
    }
    // https://stackoverflow.com/a/56537796/6565721
    html2canvas(element)
        .then(canvas => {
        document.body.appendChild(canvas);
        canvas.style.display = 'none';
        return canvas;
    })
        .then(canvas => {
        const image = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
        const a = document.createElement('a');
        a.setAttribute('download', `${fileName}.png`);
        a.setAttribute('href', image);
        a.click();
        canvas.remove();
    });
}
